import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "../../Styles/Itinerary.module.scss";
import itinerary from "../../img/England/Itinerary_England.pdf";
import { IoClose } from "react-icons/io5";
import pictureOne from "./../../img/England/Itin_1.jpeg";
import pictureTwo from "./../../img/England/Itin_3.jpeg";
import pictureThree from "./../../img/England/Itin_4.jpeg";

function ItalyItinerary() {
  const tripOne = [
    {
      day: "Day 1, Wednesday, September 24",
      text: ["Depart the USA."]
    },
    {
      day: "Day 2, Thursday, September 25",
      text: [
        "Arrive in London and settle into our hotel, visit with the group, and rest."
      ]
    },
    {
      day: "Day 3, Friday, September 26",
      text: [
        "London: Visit the Museum of Methodism, the Wesley Chapel, John Wesley’s house, and the grave of John Wesley. Adam Clarke is also buried here. Across the street is the Bunhill Fields Burial Grounds where Susannah Wesley and John Bunyon are buried. We will walk along Aldersgate Street.",
        "Other places will be visited as time permits."
      ]
    },
    {
      day: "Day 4, Saturday, September 27",
      text: [
        "In the morning drive from London to Epworth where Samuel and Susannah Wesley pastored and raised their children.",
        "In the afternoon we will tour the house and grounds of the Wesley home. This is the house where John (at the age of 5) was saved as a “brand plucked from the burning” when the house caught fire.",
        "In the evening, we will lodge at the quaint Red Lion Inn in Epworth where John Wesley stayed on occasion."
      ]
    },
    {
      day: "Day 5, Sunday, September 28",
      text: [
        "On this day, we will drive to Oxford, the home of the world-famous Oxford University where John and Charles Wesley were students. After getting settled in our hotel, we will begin our tour of Oxford. In the evening, we plan to visit Christ Church Cathedral and take in Evensong at 6:00 PM"
      ]
    },
    {
      day: "Day 6, Monday, September 29",
      text: [
        "Our tour will include a guided tour of Oxford. We will walk by places that were significant in the life of the Wesley brothers while at Oxford.",
        "We will also visit Magdalen College (part of Oxford University) where C.S Lewis was a professor. We will walk “Addison’s Walk, a picturesque footpath around a small island in the River Cherwell in the grounds of Magdalen College. It was a favoured walk of C.S. Lewis.",
        "We will endeavour to take a tour of the “Kilns” which was the home of C.S Lewis. Sometimes this is possible and at other times not possible. We will see. Holy Trinity Church is nearby, and we will be able to visit the church and graveyard where C.S. Lewis is buried.",
        "We will visit other places as time permits."
      ]
    },
    {
      day: "Day 7, Tuesday, September 30",
      text: [
        "After leaving Oxford we will drive to Bath but make a stop in the beautiful Cotswolds where we will have lunch with our own food. In the late afternoon, we will stroll around downtown Bath. Later we will drive to Bristol where we will stay overnight."
      ]
    },
    {
      day: "Day 8, Wednesday, October 1",
      text: [
        "In Bristol we will discover the world’s oldest Methodist building, John Wesley’s New Room—the Room that changed the world. Three hundred years ago, John Wesley started a mission here that sparked a worldwide movement. We will visit his 18th-century chapel and the room where he lived while in Bristol.",
        "After this, we will drive across town to the George Mueller Estate and small museum where Mueller ran his orphanages and where you can sit at the desk where he studied his Bible and prayed with thousands of orphans."
      ]
    },
    {
      day: "Day 9, Thursday, October 2",
      text: [
        "Drive back to London/airport hotel with a stop or two as time permits. These stops may include Stonehenge and/or the White Cliffs of Beachy Head (similar to the White Cliffs of Dover)."
      ]
    },
    {
      day: "Day 10, Friday, October 3",
      text: ["Fly back to the USA."]
    }
  ];

  const [justTrip, setJustTrip] = useState(false);
  const tripExample = [
    {
      day: "Day 1",
      text: ["Depart the USA."]
    },
    {
      day: "Day 2",
      text: [
        "Arrive in London and settle into our hotel, visit with the group, and rest."
      ]
    },
    {
      day: "Day 3",
      text: [
        "London: Visit the Museum of Methodism, the Wesley Chapel, John Wesley’s house, and the grave of John Wesley. Adam Clarke is also buried here. Across the street is the Bunhill Fields Burial Grounds where Susannah Wesley and John Bunyon are buried. We will walk along Aldersgate Street.",
        "Other places will be visited as time permits."
      ]
    },
    {
      day: "Day 4",
      text: [
        "In the morning drive from London to Epworth where Samuel and Susannah Wesley pastored and raised their children.",
        "In the afternoon we will tour the house and grounds of the Wesley home. This is the house where John (at the age of 5) was saved as a “brand plucked from the burning” when the house caught fire.",
        "In the evening, we will lodge at the quaint Red Lion Inn in Epworth where John Wesley stayed on occasion."
      ]
    },
    {
      day: "Day 5",
      text: [
        "On this day, we will drive to Oxford, the home of the world-famous Oxford University where John and Charles Wesley were students. After getting settled in our hotel, we will begin our tour of Oxford. In the evening, we plan to visit Christ Church Cathedral and take in Evensong at 6:00 PM"
      ]
    },
    {
      day: "Day 6",
      text: [
        "Our tour will include a guided tour of Oxford. We will walk by places that were significant in the life of the Wesley brothers while at Oxford.",
        "We will also visit Magdalen College (part of Oxford University) where C.S Lewis was a professor. We will walk “Addison’s Walk, a picturesque footpath around a small island in the River Cherwell in the grounds of Magdalen College. It was a favoured walk of C.S. Lewis.",
        "We will endeavour to take a tour of the “Kilns” which was the home of C.S Lewis. Sometimes this is possible and at other times not possible. We will see. Holy Trinity Church is nearby, and we will be able to visit the church and graveyard where C.S. Lewis is buried.",
        "We will visit other places as time permits."
      ]
    },
    {
      day: "Day 7",
      text: [
        "After leaving Oxford we will drive to Bath but make a stop in the beautiful Cotswolds where we will have lunch with our own food. In the late afternoon, we will stroll around downtown Bath. Later we will drive to Bristol where we will stay overnight."
      ]
    },
    {
      day: "Day 8",
      text: [
        "In Bristol we will discover the world’s oldest Methodist building, John Wesley’s New Room—the Room that changed the world. Three hundred years ago, John Wesley started a mission here that sparked a worldwide movement. We will visit his 18th-century chapel and the room where he lived while in Bristol.",
        "After this, we will drive across town to the George Mueller Estate and small museum where Mueller ran his orphanages and where you can sit at the desk where he studied his Bible and prayed with thousands of orphans."
      ]
    },
    {
      day: "Day 9",
      text: [
        "Drive back to London/airport hotel with a stop or two as time permits. These stops may include Stonehenge and/or the White Cliffs of Beachy Head (similar to the White Cliffs of Dover)."
      ]
    },
    {
      day: "Day 10",
      text: ["Fly back to the USA."]
    }
  ];

  const params = useParams();

  let dates = "";
  let itinerary = "";
  let trip = [];
  console.log(params.trip);

  switch (params.trip) {
    case "Spring-2026":
      dates = "May 25 - June 3, 2026";
      trip = tripOne;
      break;

    case "trip":
      dates = "";
      trip = tripExample;
      break;
  }

  useEffect(() => {
    if (params.trip === "trip") {
      setJustTrip(true);
      console.log(trip);
    } else {
      setJustTrip(false);
      console.log(trip);
    }
  }, []);
  return (
    <div className="pageContainer">
      <p className="title">Itinerary</p>
      <p className="secondaryTitle">{dates}</p>
      {!justTrip ? (
        <div className="printBox">
          <div className="print">
            <a href={itinerary} target="_blank" rel="noreferrer">
              Print PDF
            </a>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="pictureRow">
        <div>
          <img className="picture" src={pictureOne} alt="Poland town" />
        </div>
        <div className="hide">
          <img className="picture" src={pictureTwo} alt="Poland solt mines" />
        </div>
        <div>
          <img className="picture" src={pictureThree} alt="Polamd mountains" />
        </div>
      </div>

      {trip.map((el, id) => (
        <div key={id}>
          <h2 className={styles.dayNumber}>{el.day}</h2>
          {el.text.map((par) => (
            <p className="text">{par}</p>
          ))}
        </div>
      ))}
    </div>
  );
}

export default ItalyItinerary;
